import { Button } from 'components/Phantom/Button'
import { Icon } from 'components/Phantom/Icon'
import { FullScreenModal } from 'components/Phantom/_sections/ThisIsPod4Ultra'
import { Type } from 'components/Type'
import { ResponsiveVideo } from 'components/basic/Video'
import { FC, useEffect, useRef, useState } from 'react'
import { useMetricRegion } from 'stores/settings'
import styles from './Hero.module.scss'
import { HeroProps } from './Hero.types'

export const HeroConnected: FC = () => {
	const metricRegion = useMetricRegion()
	return <Hero metricRegion={metricRegion} />
}

export const Hero: FC<HeroProps> = (props) => {
	const { metricRegion = false } = props
	const [videoVisible, setVideoVisible] = useState(false)

	const videoRef = useRef<HTMLVideoElement>(null)

	useEffect(() => {
		if (videoRef.current) {
			if (videoVisible) {
				void videoRef.current.play()
			} else {
				void videoRef.current.pause()
			}
		}
	}, [videoVisible])

	return (
		<section className={styles.container}>
			<header>
				<Type.Headline1 animateOnScroll>Meet the ultimate sleep system</Type.Headline1>
			</header>

			<div className={styles.ctas}>
				<Button.Dark
					id={'hero-cta'}
					href={'/product/pod-cover'}
				>
					Shop now
				</Button.Dark>
				<Button.VideoGrey
					id={'hero-video-cta'}
					onClick={() => setVideoVisible(true)}
					className={'hide-xs'}
				>
					See how it works
				</Button.VideoGrey>
			</div>

			<div
				id={'hero-video-cta'}
				role="button"
				tabIndex={0}
				className={styles.video_container}
				onClick={() => setVideoVisible(true)}
				onKeyDown={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						setVideoVisible(true)
					}
				}}
			>
				<Icon
					name={'PlayDark'}
					color={'white'}
					size={24}
				/>
				<ResponsiveVideo
					videos={[
						{
							url: 'https://res.cloudinary.com/eightsleep/video/upload/f_auto,q_auto/hiw_hero_mobile_final.mp4',
							breakpoint: 0,
							x: 374,
							y: 460,
							thumb: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/hiw_hero_loop_thumb_mobile.jpg',
						},
						{
							url: 'https://res.cloudinary.com/eightsleep/video/upload/f_auto,q_auto/hiw_hero_desktop_final.mp4',
							breakpoint: 1024,
							x: 1440,
							y: 640,
							thumb: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/hiw_hero_loop_thumb.jpg',
						},
					]}
					preload={'auto'}
					caption={''}
				/>
			</div>

			<FullScreenModal
				closeAction={() => setVideoVisible(false)}
				visible={videoVisible}
				aspectRatio={'16/9'}
			>
				<div className={styles.modal_video_container}>
					{/* TODO: add <track> to video for captions if we have captions, for a11y purposes */}
					{/* eslint-disable-next-line jsx-a11y/media-has-caption */}
					<video
						ref={videoRef}
						src={
							metricRegion
								? 'https://res.cloudinary.com/eightsleep/video/upload/f_auto,q_auto,h_720,ar_16:9/pod_4_launch_metric_subtitles.mp4'
								: 'https://res.cloudinary.com/eightsleep/video/upload/f_auto,q_auto,h_720,ar_16:9/Pod-4-launch-with-subtitles.mp4'
						}
						preload={'none'}
						autoPlay={false}
						loop={false}
						controls
					/>
				</div>
			</FullScreenModal>
		</section>
	)
}
